export default "__VITE_ASSET__29a9def6__"